<template>
  <div id="about">
    <v-container v-if="this.$vuetify.breakpoint.mdAndUp">
      <v-row class="mb-8 pb-8" justify="center">
        <v-spacer />
        <v-col cols="3">
          <h3
            id="head"
            class="hideOverflow"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            About me
          </h3>
        </v-col>
        <v-col cols="5">
          <v-row>
            <p
              class="aboutpara hideOverflow"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              I am an undergraduate student, currently in my fourth year,
              pursuing Integrated M.Tech (B.Tech + M.Tech) in Computer Science
              at IIIT - Bangalore. I am in the process of specializing in AIML
              and Theory and Systems for computing and data. <br /><br />I am a
              coding enthusiast, an Android and Web Developer and love to learn
              and build applications to solve challenges of everyday life.
              <br /><br />I am looking for summer internship opportunities in
              computer science for Summer 2021.
            </p>
          </v-row>
        </v-col>
        <v-spacer />
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row justify="center" style="margin:0; padding:12px">
        <h3
          id="head"
          class="hideOverflow"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          About me
        </h3>
      </v-row>
      <v-row style="margin:0;padding:12px">
        <p
          class="aboutpara hideOverflow"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          I am an undergraduate student, currently in my fourth year, pursuing
          Integrated M.Tech (B.Tech + M.Tech) in Computer Science at IIIT -
          Bangalore. I am in the process of specializing in AIML and Theory and
          Systems for computing and data. <br /><br />I am a coding enthusiast,
          an Android and Web Developer and love to learn and build applications
          to solve challenges of everyday life. <br /><br />I am looking for
          summer internship opportunities in computer science for Summer 2021.
        </p>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "About",
  data: () => ({}),
  mounted() {}
};
</script>
<style scoped>
#about {
  background-color: #252734;
  margin-top: -20px;
  /* padding-bottom: 20px; */
}
.container {
  margin-left: 64px;
  padding-right: 64px;
  max-width: 100%;
}
#head {
  color: #999aa2;

  font-family: "Gilroy Regular";
  font-size: 2.5rem;
}
.aboutpara {
  color: #e9e9eb;
  font-size: 1.5rem;
  font-family: "Gilroy Medium";
  /* padding-bottom: 20px; */
}
</style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@media #{map-get(
    $display-breakpoints,
    "sm-and-down"
  )} {
  .container {
    margin-left: 0px;
    padding-right: 0px;
    margin-right: 0px;
    max-width: 100%;
  }
  .aboutRow {
    flex-direction: column;
  }
  #head {
    width: 100%;
  }
  .aboutpara {
    width: 100%;
  }
  .hideOverflow {
    overflow-x: hidden;
  }
}

@font-face {
  font-family: "Gilroy Bold";
  src: url("../assets/fonts/Gilroy-Bold.eot");
  src: url("../assets/fonts/Gilroy-Bold.eot?#iefix") format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Bold.woff") format("woff"),
    url("../assets/fonts/Gilroy-Bold.otf") format("opentype"),
    url("../assets/fonts/Gilroy-Bold.ttf") format("truetype"),
    url("../assets/fonts/Gilroy-Bold.svg") format("svg");
}
@font-face {
  font-family: "Gilroy SemiBold";
  src: url("../assets/fonts/Gilroy-SemiBold.eot");
  src: url("../assets/fonts/Gilroy-SemiBold.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-SemiBold.woff") format("woff"),
    url("../assets/fonts/Gilroy-SemiBold.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Medium";
  src: url("../assets/fonts/Gilroy-Medium.eot");
  src: url("../assets/fonts/Gilroy-Medium.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Medium.woff") format("woff"),
    url("../assets/fonts/Gilroy-Medium.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Regular";
  src: url("../assets/fonts/Gilroy-Regular.eot");
  src: url("../assets/fonts/Gilroy-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Regular.woff") format("woff"),
    url("../assets/fonts/Gilroy-Regular.otf") format("opentype");
}
</style>
